export const LIST_BANK = [
  {
    id: 1,
    name: 'Ngân hàng TMCP Công thương Việt Nam',
    shortName: 'VietinBank'
  },
  {
    id: 2,
    name: 'Ngân hàng TMCP Ngoại Thương Việt Nam',
    shortName: 'Vietcombank'
  },
  {
    id: 3,
    name: 'Ngân hàng TMCP Đầu tư và Phát triển Việt Nam',
    shortName: 'BIDV'
  },
  {
    id: 4,
    name: 'Ngân hàng Nông nghiệp và Phát triển Nông thôn Việt Nam',
    shortName: 'Agribank'
  },
  {
    id: 5,
    name: 'Ngân hàng TMCP Phương Đông',
    shortName: 'OCB'
  },
  {
    id: 6,
    name: 'Ngân hàng TMCP Quân đội',
    shortName: 'MBBank'
  },
  {
    id: 7,
    name: 'Ngân hàng TMCP Kỹ thương Việt Nam',
    shortName: 'Techcombank'
  },
  {
    id: 8,
    name: 'Ngân hàng TMCP Á Châu',
    shortName: 'ACB'
  },
  {
    id: 9,
    name: 'Ngân hàng TMCP Việt Nam Thịnh Vượng',
    shortName: 'VPBank'
  },
  {
    id: 10,
    name: 'Ngân hàng TMCP Tiên Phong',
    shortName: 'TPBank'
  },
  {
    id: 11,
    name: 'Ngân hàng TMCP Sài Gòn Thương Tín',
    shortName: 'Sacombank'
  },
  {
    id: 12,
    name: 'Ngân hàng TMCP Phát triển Thành phố Hồ Chí Minh',
    shortName: 'HDBank'
  },
  {
    id: 13,
    name: 'Ngân hàng TMCP Bản Việt',
    shortName: 'VietCapitalBank'
  },
  {
    id: 14,
    name: 'Ngân hàng TMCP Sài Gòn',
    shortName: 'SCB'
  },
  {
    id: 15,
    name: 'Ngân hàng TMCP Quốc tế Việt Nam',
    shortName: 'VIB'
  },
  {
    id: 16,
    name: 'Ngân hàng TMCP Sài Gòn - Hà Nội',
    shortName: 'SHB'
  },
  {
    id: 17,
    name: 'Ngân hàng TMCP Xuất Nhập khẩu Việt Nam',
    shortName: 'Eximbank'
  },
  {
    id: 18,
    name: 'Ngân hàng TMCP Hàng Hải',
    shortName: 'MSB'
  },
  {
    id: 19,
    name: 'TMCP Việt Nam Thịnh Vượng - Ngân hàng số CAKE by VPBank',
    shortName: 'CAKE'
  },
  {
    id: 20,
    name: 'TMCP Việt Nam Thịnh Vượng - Ngân hàng số Ubank by VPBank',
    shortName: 'Ubank'
  },
  {
    id: 21,
    name: 'Ngân hàng số Timo by Ban Viet Bank (Timo by Ban Viet Bank)',
    shortName: 'Timo'
  },
  {
    id: 22,
    name: 'Tổng Công ty Dịch vụ số Viettel - Chi nhánh tập đoàn công nghiệp viễn thông Quân Đội',
    shortName: 'ViettelMoney'
  },
  {
    id: 23,
    name: 'VNPT Money',
    shortName: 'VNPTMoney'
  },
  {
    id: 24,
    name: 'Ngân hàng TMCP Sài Gòn Công Thương',
    shortName: 'SaigonBank'
  },
  {
    id: 25,
    name: 'Ngân hàng TMCP Bắc Á',
    shortName: 'BacABank'
  },
  {
    id: 26,
    name: 'Ngân hàng TMCP Đại Chúng Việt Nam',
    shortName: 'PVcomBank'
  },
  {
    id: 27,
    name: 'Ngân hàng Thương mại TNHH MTV Đại Dương',
    shortName: 'Oceanbank'
  },
  {
    id: 28,
    name: 'Ngân hàng TMCP Quốc Dân',
    shortName: 'NCB'
  },
  {
    id: 29,
    name: 'Ngân hàng TNHH MTV Shinhan Việt Nam',
    shortName: 'ShinhanBank'
  },
  {
    id: 30,
    name: 'Ngân hàng TMCP An Bình',
    shortName: 'ABBANK'
  },
  {
    id: 31,
    name: 'Ngân hàng TMCP Việt Á',
    shortName: 'VietABank'
  },
  {
    id: 32,
    name: 'Ngân hàng TMCP Nam Á',
    shortName: 'NamABank'
  },
  {
    id: 33,
    name: 'Ngân hàng TMCP Xăng dầu Petrolimex',
    shortName: 'PGBank'
  },
  {
    id: 34,
    name: 'Ngân hàng TMCP Việt Nam Thương Tín',
    shortName: 'VietBank'
  },
  {
    id: 35,
    name: 'Ngân hàng TMCP Bảo Việt',
    shortName: 'BaoVietBank'
  },
  {
    id: 36,
    name: 'Ngân hàng TMCP Đông Nam Á',
    shortName: 'SeABank'
  },
  {
    id: 37,
    name: 'Ngân hàng Hợp tác xã Việt Nam',
    shortName: 'COOPBANK'
  },
  {
    id: 38,
    name: 'Ngân hàng TMCP Lộc Phát Việt Nam',
    shortName: 'LPBank'
  },
  {
    id: 39,
    name: 'Ngân hàng TMCP Kiên Long',
    shortName: 'KienLongBank'
  },
  {
    id: 40,
    name: 'Ngân hàng Đại chúng TNHH Kasikornbank',
    shortName: 'KBank'
  },
  {
    id: 41,
    name: 'Ngân hàng Kookmin - Chi nhánh Hà Nội',
    shortName: 'KookminHN'
  },
  {
    id: 42,
    name: 'Ngân hàng KEB Hana – Chi nhánh Thành phố Hồ Chí Minh',
    shortName: 'KEBHanaHCM'
  },
  {
    id: 43,
    name: 'Ngân hàng KEB Hana – Chi nhánh Hà Nội',
    shortName: 'KEBHANAHN'
  },
  {
    id: 44,
    name: 'Công ty Tài chính TNHH MTV Mirae Asset (Việt Nam) ',
    shortName: 'MAFC'
  },
  {
    id: 45,
    name: 'Ngân hàng Citibank, N.A. - Chi nhánh Hà Nội',
    shortName: 'Citibank'
  },
  {
    id: 46,
    name: 'Ngân hàng Kookmin - Chi nhánh Thành phố Hồ Chí Minh',
    shortName: 'KookminHCM'
  },
  {
    id: 47,
    name: 'Ngân hàng Chính sách Xã hội',
    shortName: 'VBSP'
  },
  {
    id: 48,
    name: 'Ngân hàng TNHH MTV Woori Việt Nam',
    shortName: 'Woori'
  },
  {
    id: 49,
    name: 'Ngân hàng Liên doanh Việt - Nga',
    shortName: 'VRB'
  },
  {
    id: 50,
    name: 'Ngân hàng United Overseas - Chi nhánh TP. Hồ Chí Minh',
    shortName: 'UnitedOverseas'
  },
  {
    id: 51,
    name: 'Ngân hàng TNHH MTV Standard Chartered Bank Việt Nam',
    shortName: 'StandardChartered'
  },
  {
    id: 52,
    name: 'Ngân hàng TNHH MTV Public Việt Nam',
    shortName: 'PublicBank'
  },
  {
    id: 53,
    name: 'Ngân hàng Nonghyup - Chi nhánh Hà Nội',
    shortName: 'Nonghyup'
  },
  {
    id: 54,
    name: 'Ngân hàng TNHH Indovina',
    shortName: 'IndovinaBank'
  },
  {
    id: 55,
    name: 'Ngân hàng Công nghiệp Hàn Quốc - Chi nhánh TP. Hồ Chí Minh',
    shortName: 'IBKHCM'
  },
  {
    id: 56,
    name: 'Ngân hàng Công nghiệp Hàn Quốc - Chi nhánh Hà Nội',
    shortName: 'IBKHN'
  },
  {
    id: 57,
    name: 'Ngân hàng TNHH MTV HSBC (Việt Nam)',
    shortName: 'HSBC'
  },
  {
    id: 58,
    name: 'Ngân hàng TNHH MTV Hong Leong Việt Nam',
    shortName: 'HongLeong'
  },
  {
    id: 59,
    name: 'Ngân hàng Thương mại TNHH MTV Dầu Khí Toàn Cầu',
    shortName: 'GPBank'
  },
  {
    id: 60,
    name: 'Ngân hàng TMCP Đông Á',
    shortName: 'DongABank'
  },
  {
    id: 61,
    name: 'DBS Bank Ltd - Chi nhánh Thành phố Hồ Chí Minh',
    shortName: 'DBSBank'
  },
  {
    id: 62,
    name: 'Ngân hàng TNHH MTV CIMB Việt Nam',
    shortName: 'CIMB'
  },
  {
    id: 63,
    name: 'Ngân hàng Thương mại TNHH MTV Xây dựng Việt Nam',
    shortName: 'CBBank'
  }
];
